<template>
	<div class="or-wrap-content">
		<a id="Organisation" name="Organisation"></a>
		<h3 v-html="translations.orTitle"></h3>
		<div class="or-wrap-section">
			<p v-html="translations.orContent1"></p>
			<div class="or-text-spacer"></div>
			<p v-html="translations.orContent2"></p>
			<div class="or-text-spacer"></div>
			<span v-html="translations.orContent3"></span>
			<span>: Prof. Dr. Christian Thies</span><br />
			<span v-html="translations.orContent4"></span>
			<span>: christian.thies@reutlingen-university.de</span>
			<p>
				<span v-html="translations.orContent5"></span>
				<a href="https://artemis.reutlingen-university.de/" target="_blank"> https://artemis.reutlingen-university.de/</a>
			</p>
			<div class="or-text-spacer"></div>
			<p v-html="translations.orContent6"></p>
			<div class="or-text-spacer"></div>
			<span v-html="translations.orContent3"></span>
			<span>: Dr. Fee Schmitt</span> <br />
			<span v-html="translations.orContent4"></span>
			<span>: Fee.Schmitt@med.uni-tuebingen.de</span>
			<p>
				<span v-html="translations.orContent5"></span>
				<a href="https://zpm-verbund.de/de/zpm/universitaetsklinikum-tuebingen/" target="_blank">
					https://zpm-verbund.de/de/zpm/universitaetsklinikum-tuebingen/</a
				>
			</p>
			<div class="or-text-spacer"></div>
			<p v-html="translations.orContent7"></p>
			<div class="or-text-spacer"></div>
			<span v-html="translations.orContent3"></span>
			<span>: Prof. Dr. Nisar Malek</span> <br />
			<span v-html="translations.orContent4"></span>
			<span>: nisar.malek@med.uni-tuebingen.de</span>
			<p>
				<span v-html="translations.orContent5"></span>
				<a
					href="https://www.medizin.uni-tuebingen.de/de/das-klinikum/einrichtungen/kliniken/medizinische-klinik/innere-medizin-1"
					target="_blank"
				>
					https://www.medizin.uni-tuebingen.de/de/das-klinikum/einrichtungen/kliniken/medizinische-klinik/innere-medizin-1</a
				>
			</p>
		</div>
	</div>
</template>

<script>
import i18n from '@/translations/i18n';
export default {
	name: 'Organisation',
	data() {
		return {
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				orTitle: this.$t('orTitle'),
				orContent1: this.$t('orContent1'),
				orContent2: this.$t('orContent2'),
				orContent3: this.$t('orContent3'),
				orContent4: this.$t('orContent4'),
				orContent5: this.$t('orContent5'),
				orContent6: this.$t('orContent6'),
				orContent7: this.$t('orContent7'),
			};
		},
	},
	created() {
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
	},
};
</script>

<style scoped>
.or-wrap-section {
	font-size: 20px;
	color: var(--main-color-text-light);
	height: fit-content;
	background-color: #ffffff40;
	padding: 10px 5vw;
	box-sizing: border-box;
	text-align: justify;
}

.or-wrap-section p {
	display: block;
	margin: 0px;
}

.or-text-spacer {
	height: 20px;
}
</style>
